import { TestIdProp } from '@acin/user-accounts/types/src/helpers/testId';
import React from 'react';
import {
  IInternalMappingsJobStatus,
  IInternalRegulationDocumentReviewStatus,
  IInternalRegulationObligationReviewStatus,
  IInternalRegulationObligationRuleReviewStatus,
  IInternalRegulationReviewStatus,
} from '../../../graphql/generated';
import * as SC from './StatusBadge.styled';

export interface StatusBadgeProps extends TestIdProp {
  className?: string;
  status?:
    | IInternalRegulationReviewStatus
    | IInternalRegulationDocumentReviewStatus
    | IInternalRegulationObligationReviewStatus
    | IInternalRegulationObligationRuleReviewStatus
    | IInternalMappingsJobStatus
    | null;
}

export const StatusBadge: React.FC<StatusBadgeProps> = (props) => {
  const { status } = props;

  const getStatus = () => {
    switch (status) {
      case IInternalRegulationReviewStatus.ToReview:
      case IInternalRegulationDocumentReviewStatus.ToReview:
      case IInternalRegulationObligationReviewStatus.ToReview:
      case IInternalRegulationObligationRuleReviewStatus.ToReview:
        return <SC.StatusBadge text="To Review" variant="noData" />;
      case IInternalRegulationReviewStatus.InProgress:
      case IInternalRegulationDocumentReviewStatus.InProgress:
      case IInternalRegulationObligationReviewStatus.InProgress:
      case IInternalMappingsJobStatus.InProgress:
        return <SC.StatusBadge text="In Progress" variant="primary" />;
      case IInternalRegulationReviewStatus.Reviewed:
      case IInternalRegulationDocumentReviewStatus.Reviewed:
      case IInternalRegulationObligationReviewStatus.Reviewed:
      case IInternalRegulationObligationRuleReviewStatus.Reviewed:
        return <SC.StatusBadge text="Reviewed" variant="success" />;
      case IInternalMappingsJobStatus.Published:
        return <SC.StatusBadge text="Published" variant="success" />;
      case IInternalMappingsJobStatus.MappingsCreated:
        return <SC.StatusBadge text="Mappings Created" variant="dataVis3" />;
      default:
        return null;
    }
  };

  return getStatus();
};
